var React = require('react');

function CompassDirection (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"compass-direction"),React.createElement("path",{"d":"M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5.74,7.069L11.632,18.815h0a.6.6,0,0,1-.531.323.577.577,0,0,1-.143-.017.6.6,0,0,1-.458-.583V13.6a.1.1,0,0,0-.1-.1H5.462a.6.6,0,0,1-.277-1.132L16.932,6.259a.6.6,0,0,1,.808.81Z","key":1})]);
}

CompassDirection.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CompassDirection;

CompassDirection.default = CompassDirection;
